export const GuideVisualSection = ({
  imageSrc,
  imageAlt,
  testIdPrefix = 'guide-visual-section',
}) => {
  if (!imageSrc) return null;

  return (
    <div
      className="overflow-hidden rounded-xl border border-[#D4AF37]/40 bg-white shadow-[0_20px_50px_rgba(28,25,23,0.08)]"
      data-testid={`${testIdPrefix}-image-wrap`}
    >
      <img
        src={imageSrc}
        alt={imageAlt}
        className="h-auto w-full"
        loading="eager"
        width="1600"
        height="900"
        data-testid={`${testIdPrefix}-image`}
      />
    </div>
  );
};
